import moment from 'moment';
import { combineReducers } from 'redux';
import * as types from './action_types';

const buildDefaultFilter = () => {
  const dateTo = moment().seconds(0).milliseconds(0);
  const dateFrom = moment(dateTo).subtract(1, 'day');
  return {
    userId: '',
    dateFrom: dateFrom.format('YYYY-MM-DDTHH:mm'),
    dateTo: dateTo.format('YYYY-MM-DDTHH:mm'),
  };
};

const initialFilter = buildDefaultFilter();
const initialNavi = {
  limit: 50,
  after: null,
  history: [],
  canNext: false,
  canPrev: false,
};

function eventlogs(state = [], action) {
  switch (action.type) {
    case types.RECEIVE_EVENTLOGS:
      return [].concat(action.eventlogs);
    default:
      return state;
  }
}

function eventlog(state = null, action) {
  switch (action.type) {
    case types.RECEIVE_EVENTLOG:
      if (action.eventlog) {
        return $.extend({}, action.eventlog);
      }
      return null;
    case types.RECEIVE_EVENTLOGS:
      return null;
    case types.ERROR:
      if (state && $.isPlainObject(state)) {
        state.errors = action.errorObj;
      }
      return state;
    default:
      return state;
  }
}

function errors(state = [], action) {
  switch (action.type) {
    case types.RECEIVE_EVENTLOGS:
    case types.RECEIVE_EVENTLOG:
      return [];
    case types.ERROR:
      return action.errors;
    default:
      return state;
  }
}

function filter(state = initialFilter, action) {
  switch (action.type) {
    case types.SET_FILTER:
      return $.extend({}, state, action.filter);
    default:
      return state;
  }
}

function navi(state = initialNavi, action) {
  switch (action.type) {
    case types.RECEIVE_EVENTLOGS:
      return $.extend({}, initialNavi, action.navi);
    default:
      return state;
  }
}

export default combineReducers({
  eventlogs,
  eventlog,
  filter,
  navi,
  errors,
});
